import React from 'react';
import Navbar from '../components/Layouts/Navbar';
import Footer from '../components/Layouts/Footer';
import PageSeo from '../components/Common/PageSeo';
import SubscribeStyleOne from '../components/Common/SubscribeStyleOne';
import ManagedServicesHeader from '../components/ManagedServices/ManagedServicesHeader';
import ManagedServicesOverview from '../components/ManagedServices/ManagedServicesOverview';
import ManagedServicesProcess from '../components/ManagedServices/ManagedServicesProcess';
import ManagedServicesServiceCards from '../components/ManagedServices/ManagedServicesServiceCards';
import ManagedServicesCta from '../components/ManagedServices/ManagedServicesCta';
import ManagedServicesBlogPosts from '../components/ManagedServices/ManagedServicesBlogPosts';
import { fetchBlogPostsForZeroTrustVpn } from '../lib/blogApi';
import { useTranslations } from '../locales/useTranslations';
import { useRouter } from 'next/router';

const ManagedServicesPage = ({ relatedBlogPosts = [] }) => {
  const { t } = useTranslations();
  const { locale } = useRouter();
  const baseUrl = locale === 'en' ? 'https://simplify-data.com' : 'https://simplify-data.de';

  return (
    <>
      <PageSeo
        title={t('managedServices_page_title')}
        description={t('managedServices_page_description')}
        canonical={`${baseUrl}/managed-services/`}
        openGraph={{
          url: `${baseUrl}/managed-services/`,
          title: t('managedServices_page_title'),
          description: t('managedServices_page_description'),
          images: [
            {
              url: `${baseUrl}/images/simplify-data.png`,
              width: 1200,
              height: 1200,
              alt: t('managedServices_header_badge'),
              type: 'image/jpeg',
            },
          ],
          siteName: 'Simplify Data',
          locale: locale === 'en' ? 'en_US' : 'de_DE',
          type: 'website',
        }}
        additionalMetaTags={[
          {
            name: 'keywords',
            content: t('managedServices_page_keywords'),
          },
        ]}
        additionalLinkTags={[
          {
            rel: 'alternate',
            hrefLang: 'de',
            href: 'https://simplify-data.de/managed-services/',
          },
          {
            rel: 'alternate',
            hrefLang: 'en',
            href: 'https://simplify-data.com/managed-services/',
          },
        ]}
      />
      <Navbar />
      <ManagedServicesHeader />
      <ManagedServicesOverview />
      <ManagedServicesProcess />
      <ManagedServicesServiceCards />
      <ManagedServicesCta />
      <ManagedServicesBlogPosts
        posts={relatedBlogPosts}
        badgeKey="managedServices_blog_badge"
        titleKey="managedServices_blog_title"
        subtitleKey="managedServices_blog_subtitle"
        ctaKey="managedServices_blog_cta"
      />
      <SubscribeStyleOne />
      <Footer />
    </>
  );
};

export default ManagedServicesPage;

export async function getStaticProps({ locale }) {
  try {
    const relatedBlogPosts = await fetchBlogPostsForZeroTrustVpn(locale || 'de', 6);
    return {
      props: { relatedBlogPosts },
      revalidate: 3600,
    };
  } catch {
    return {
      props: { relatedBlogPosts: [] },
      revalidate: 600,
    };
  }
}
